import React from 'react';
import PropTypes from 'prop-types';

import ListItemSelect from '../ListItemSelect';
import Text, { TextProps } from '../Text';
import Box from '../Box';
import { Location as LocationIcon } from '@wix/wix-ui-icons-common';
import { st, classes } from './AddressInputItem.st.css';
import {
  AddressInputItemProps,
  AddressInputItemBuilderProps,
} from './AddressInputItem.types';
import { DropdownLayoutValueOption } from '../DropdownLayout';
import { OPTION_LAYOUT } from './constants';

/** This component is used to display an address item mainly in <AddressInput/> component. */
class AddressInputItem extends React.PureComponent<AddressInputItemProps> {
  static displayName = 'AddressInputItem';

  static defaultProps = {
    optionLayout: 'single-line',
    prefix: <LocationIcon />,
  };

  static propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    mainLabel: PropTypes.string,
    secondaryLabel: PropTypes.string,
    optionLayout: PropTypes.oneOf(Object.values(OPTION_LAYOUT)),
    prefix: PropTypes.node,
    suffix: PropTypes.node,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    highlighted: PropTypes.bool,
    onClick: PropTypes.func,
  };

  render() {
    const {
      dataHook,
      className,
      secondaryLabel,
      optionLayout,
      mainLabel,
      suffix,
      prefix,
      disabled,
      selected,
      highlighted,
      onClick,
    } = this.props;

    const textProps: TextProps = {
      tagName: 'div',
      ellipsis: true,
      skin: disabled ? 'disabled' : 'standard',
      light: selected,
    };

    return (
      <ListItemSelect
        dataHook={dataHook}
        className={st(classes.root, { optionLayout }, className)}
        subtitle={secondaryLabel}
        title={<Text {...textProps}>{mainLabel}</Text>}
        suffix={<Box>{suffix}</Box>}
        prefix={<Box>{prefix}</Box>}
        ellipsis
        disabled={disabled}
        selected={selected}
        highlighted={highlighted}
        onClick={onClick}
      />
    );
  }
}

export const addressInputItemBuilder = ({
  id,
  className,
  prefix,
  mainLabel,
  secondaryLabel,
  suffix,
  disabled,
  dataHook,
  optionLayout,
  onClick,
  displayLabel,
}: AddressInputItemBuilderProps): DropdownLayoutValueOption => ({
  id,
  disabled,
  overrideOptionStyle: true,
  label: displayLabel,
  value: ({ selected, hovered, ...rest }) => (
    <AddressInputItem
      optionLayout={optionLayout}
      dataHook={dataHook}
      className={className}
      prefix={prefix}
      mainLabel={mainLabel}
      secondaryLabel={secondaryLabel}
      suffix={suffix}
      selected={selected}
      highlighted={hovered}
      onClick={onClick}
      {...rest}
    />
  ),
});

export default AddressInputItem;
